import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Copy, Check, CheckButton, HorizontalRule } from '@elparking/components'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'

const MultiOptionsFilter = ({ title, options, filter, setFilters, keyId, disabled, isHorizontal }) => {
    const onChange = (value) => {
        trackTealiumEvent(RentalCarEvents.applyFiltersLink)
        if (filter.includes(value)) {
            setFilters(filter.filter((item) => item !== value))
        } else {
            setFilters([...filter, value])
        }
    }

    if (!options) return null

    return (
        <Flex flexDirection='column' margin='0.1em 0'>
            <Copy as='h3' padding='0' fontSize='small' fontColor='gray' >{title}</Copy>
            <Flex alignItems={isHorizontal ? 'center' : 'flex-start'} justifyContent={isHorizontal ? 'space-between' : 'center'} marginTop='1em' width='100%' flexDirection={isHorizontal ? 'row' : 'column'}>
                {options.map((option) => <Box marginBottom='0.5em' key={keyId + option.value}>
                    <Check
                      aria-checked={filter.includes(option.value)}
                      id={keyId + option.value}
                      name={option.value}
                      label={!isHorizontal && <Copy fontColor='gray90' >{option.label}</Copy>}
                      labelComponent={isHorizontal && <Copy fontColor='gray90' padding='8px' fontWeight='regular' fontSize='small' >{option.label}</Copy>}
                      fontSize='xSmall'
                      fontWeight='regular'
                      type='checkbox'
                      checkButtonElement={isHorizontal ? CheckButton.labelInside : CheckButton.iconFilled}
                      checked={filter.includes(option.value)}
                      squared
                      onChange={() => onChange(option.value)}
                      disabled={disabled}
                      height='35px'
                    /></Box>
                )}
            </Flex>
            <HorizontalRule />
        </Flex>
    )
}

MultiOptionsFilter.propTypes = {
    title: PropTypes.node,
    options: PropTypes.array,
    keyId: PropTypes.string,
    filter: PropTypes.any,
    setFilters: PropTypes.func,
    disabled: PropTypes.bool,
    isHorizontal: PropTypes.bool,
}

export default MultiOptionsFilter
